/**
 * Service module for the Search hub entity
 * @module SearchHubService
 *
 * This module contains all requests regarding the search hub.
 * The purpose is to place requests that are only related to search hub.
 */
import { SearchHubAxios } from '@/config/axios';

/**
 * Returns the banks information in an array
 * @param {object} config Represents an Axios request config object
 * @returns {Promise} Axios promise object represents the rooftop information
 */
export function getBanks(config = {}) {
  return SearchHubAxios.get('/search-hub', config);
}

/**
 * Returns the bank information in an object
 * @param {string} id Represents the bank_id of the seller
 * @param {object} config Represents an Axios request config object
 * @returns {Promise} Axios promise object represents the rooftop information
 */
export function getBank(id, config = {}) {
  return SearchHubAxios.get(`/search-hub/${id}`, config);
}

export default {
  getBanks,
  getBank,
};
